import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";

import axios from "../../../configAxios";

import RentalItem from "./RentalItem";
import CardHeader from "../CardHeader";

import Spinner from "../../../assests/images/spinner.gif";

class RentalRequests extends Component {
  signal = axios.CancelToken.source();
  state = {
    loading: false,
    tickets: []
  };

  componentDidMount() {
    this.setState({ ...this.state, loading: true })
    let params = {
      per_page: 5,
      order: {
        column: "created_at",
        dir: "desc"
      }
    }
    axios.get('/tickets', { params, cancelToken: this.signal.token })
      .then(res => {
        this.setState({
          ...this.state,
          loading: false,
          tickets: res.data.tickets
        })
      })
      .catch(error => error)
    this.props.updateGrid();
  }

  componentWillUnmount() {
    this.signal.cancel('Request is being Cancelled');
  }

  render() {
    const spinner = (
      <img
        src={Spinner}
        style={{ width: "100px", margin: "auto", display: "block" }}
        alt="Loading..."
      />
    );
    return (
      <div className="dashboard">
        <div className="card">
          {this.state.loading ? (
            <div className="card-body p-0">
              <div className="card-text">
                <div className="spinner">{spinner}</div>
              </div>
            </div>
          ) : (
              <div>
                <CardHeader
                  title={"Rental Requests"}
                  icon="fa-compact-disc"
                  collapse="rental"
                  updateGrid={this.props.updateGrid}
                  removeModule={this.props.removeModule}
                  name={this.props.name} />
                <div className="dashboard-card collapse show" id="rental">
                  <div className="card-body p-0">
                    <ul className="list-group">
                      {this.state.tickets.map(ticket => (
                        <RentalItem key={ticket.id} ticket={ticket} />
                      ))}
                    </ul>
                    <div className="p-2 text-center cursor card-text" style={{ height: "40px" }}>
                      <Link to="/assets/rental_requests" className="text-info">View All</Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withRouter(RentalRequests);